import * as React from "react";
import { Button, ListGroup, ListGroupItem } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { EmptyPlaceholder, FlexLayout, Icon, } from "../../../controls/api";
import * as util from "../../../util/api";
import { ComponentEx } from "../../../controls/ComponentEx";
import * as selectors from "../../../util/selectors";
import { genCollectionLoadOrder } from "../util";
const NAMESPACE = "generic-load-order-extension";
class LoadOrderCollections extends ComponentEx {
    static getDerivedStateFromProps(newProps, state) {
        const { loadOrder, mods, collection } = newProps;
        const sortedMods = genCollectionLoadOrder(loadOrder, mods, collection);
        return sortedMods !== state.sortedMods ? { sortedMods } : null;
    }
    constructor(props) {
        super(props);
        const { loadOrder, mods, collection } = props;
        this.initState({
            sortedMods: genCollectionLoadOrder(loadOrder, mods, collection) || {},
        });
    }
    componentDidMount() {
        const { loadOrder, mods, collection } = this.props;
        this.nextState.sortedMods = genCollectionLoadOrder(loadOrder, mods, collection);
    }
    render() {
        const { t } = this.props;
        const { sortedMods } = this.state;
        return !!sortedMods && Object.keys(sortedMods).length !== 0 ? (React.createElement("div", { style: { overflow: "auto" } },
            React.createElement("h4", null, t("Load Order")),
            React.createElement("p", null, t("This is a snapshot of the load order information that " +
                "will be exported with this collection.")),
            this.renderLoadOrderEditInfo(),
            React.createElement(ListGroup, { id: "collections-load-order-list" }, Object.keys(sortedMods).map(this.renderModEntry)))) : (this.renderPlaceholder());
    }
    renderLoadOrderEditInfo = () => {
        const { t } = this.props;
        return (React.createElement(FlexLayout, { type: "row", id: "collection-edit-loadorder-edit-info-container" },
            React.createElement(FlexLayout.Fixed, { className: "loadorder-edit-info-icon" },
                React.createElement(Icon, { name: "dialog-info" })),
            React.createElement(FlexLayout.Fixed, { className: "collection-edit-loadorder-edit-info" },
                t("You can make changes to this data from the "),
                React.createElement("a", { className: "fake-link", onClick: this.openLoadOrderPage, title: t("Go to Load Order Page") }, t("Load Order page.")),
                t(" If you believe a load order entry is missing, please ensure the " +
                    "relevant mod is enabled and has been added to the collection."),
                t(" Note that some games will require the mods to be enabled or deployed " +
                    "in order for the load order to be generated."))));
    };
    openLoadOrderPage = () => {
        this.context.api.events.emit("show-main-page", "generic-loadorder");
    };
    renderOpenLOButton = () => {
        const { t } = this.props;
        return (React.createElement(Button, { id: "btn-more-mods", className: "collection-add-mods-btn", onClick: this.openLoadOrderPage, bsStyle: "ghost" }, t("Open Load Order Page")));
    };
    renderPlaceholder = () => {
        const { t } = this.props;
        return (React.createElement(EmptyPlaceholder, { icon: "sort-none", text: t("You have no load order entries (for the current mods in the collection)"), subtext: this.renderOpenLOButton() }));
    };
    renderModEntry = (modId) => {
        const loEntry = this.state.sortedMods[modId];
        const key = modId + JSON.stringify(loEntry);
        const name = util.renderModName(this.props.mods[modId]);
        const classes = ["load-order-entry", "collection-tab"];
        return (React.createElement(ListGroupItem, { key: key, className: classes.join(" ") },
            React.createElement(FlexLayout, { type: "row" },
                React.createElement("p", { className: "load-order-index" }, loEntry.pos),
                React.createElement("p", null, name))));
    };
}
const empty = {};
function mapStateToProps(state, ownProps) {
    const profile = selectors.activeProfile(state) || undefined;
    let loadOrder = {};
    if (!!profile?.gameId) {
        loadOrder = util.getSafe(state, ["persistent", "loadOrder", profile.id], empty);
    }
    return {
        gameId: profile?.gameId,
        loadOrder,
        mods: util.getSafe(state, ["persistent", "mods", profile.gameId], {}),
        profile,
    };
}
function mapDispatchToProps(dispatch) {
    return {};
}
export default withTranslation(["common", NAMESPACE])(connect(mapStateToProps, mapDispatchToProps)(LoadOrderCollections));
